// AUTO-GENERATED by scripts/gen-config.mjs from project.config.json. Do not edit.
export const PROJECT = {
  "name": "ImmoAktas",
  "slug": "immoaktas",
  "short": "ia",
  "tagline": "Nebenkosten einfach abrechnen.",
  "domain": "immoaktas.com",
  "bundleId": "com.immoaktas.app",
  "version": "1.5.0",
  "modules": {
    "mobile": true,
    "landing": true,
    "server": true,
    "web": true,
    "admin": true,
    "ai": true,
    "paymentsMobile": true,
    "paymentsWeb": true,
    "uploads": true,
    "push": true
  },
  "languages": {
    "default": "de",
    "enabled": [
      "de",
      "en"
    ]
  },
  "brand": {
    "bg": "#F3F4F1",
    "fg": "#121614",
    "primary": "#0F5C4C",
    "accent": "#FF7A45",
    "fontDisplay": "Sora",
    "fontBody": "IBM Plex Sans"
  },
  "urls": {
    "landing": "https://immoaktas.com",
    "web": "https://app.immoaktas.com",
    "api": "https://api.immoaktas.com",
    "admin": "https://admin.immoaktas.com",
    "media": "https://media.immoaktas.com"
  },
  "products": [
    {
      "id": "immoaktas_pro_yearly",
      "type": "subscription",
      "period": "P1Y",
      "note": "Store-Pakete siehe storePackages, Web-Staffel siehe pricing"
    },
    {
      "id": "immoaktas_ai_yearly",
      "type": "subscription",
      "period": "P1Y",
      "note": "KI-Assistent als Zusatz für das ganze Konto, eigene Abo-Gruppe, siehe aiAddon"
    },
    {
      "id": "immoaktas_premium_yearly",
      "type": "subscription",
      "period": "P1Y",
      "note": "Alt (bis 2026-10-21): Premium 6 Einheiten + KI-Assistent, siehe premium. Wird nicht mehr verkauft"
    }
  ],
  "aiAddon": {
    "productId": "immoaktas_ai_yearly",
    "entitlement": "ai",
    "webPriceCentsYear": 4900,
    "storePriceCentsYear": 5899,
    "agent": true,
    "agentTrialMessages": 30,
    "note": "KI-Assistent als Zusatz für das ganze Konto (Entscheidung 2026-10-21), brutto im Jahr, gewährt keine Einheiten. Web: Stripe-Preis STRIPE_AI_PRICE_ID (fest, Menge 1) als zweite Position im Einheiten-Abo oder allein. Store: Produkt-ID productId in eigener Abo-Gruppe, Entitlement ai in RevenueCat."
  },
  "premium": {
    "productId": "immoaktas_premium_yearly",
    "entitlement": "premium",
    "priceCentsYear": 11900,
    "includedUnits": 6,
    "note": "Alt (2026-10-16 bis 2026-10-21), wird nicht mehr verkauft. Laufende Käufe (Web STRIPE_PREMIUM_PRICE_ID, Store productId, Entitlement premium) gewähren bis zum Ablauf weiter max(includedUnits, Einheiten) und den KI-Assistenten."
  },
  "pricing": {
    "freeUnits": 1,
    "currency": "EUR",
    "quoteFromUnits": 100,
    "tiersCentsPerUnitYear": [
      {
        "fromUnit": 2,
        "toUnit": 10,
        "cents": 1490
      },
      {
        "fromUnit": 11,
        "toUnit": 25,
        "cents": 990
      },
      {
        "fromUnit": 26,
        "toUnit": 50,
        "cents": 690
      },
      {
        "fromUnit": 51,
        "toUnit": null,
        "cents": 490
      }
    ]
  },
  "storePackages": {
    "productIdPattern": "immoaktas_units_<n>_yearly",
    "note": "Jahrespakete per In-App-Kauf (Preise seit 2026-10-21: Web-Staffel × 1,2, auf ,99 gerundet). Preise leben in App Store/Play, die App zeigt sie aus RevenueCat. displayCents nur als Referenz für Doku und Store-Pflege.",
    "packages": [
      {
        "units": 2,
        "displayCents": 1799
      },
      {
        "units": 3,
        "displayCents": 3599
      },
      {
        "units": 4,
        "displayCents": 5399
      },
      {
        "units": 5,
        "displayCents": 7199
      },
      {
        "units": 6,
        "displayCents": 8999
      },
      {
        "units": 7,
        "displayCents": 10799
      },
      {
        "units": 8,
        "displayCents": 12599
      },
      {
        "units": 9,
        "displayCents": 14299
      },
      {
        "units": 10,
        "displayCents": 15999
      },
      {
        "units": 15,
        "displayCents": 21999
      },
      {
        "units": 20,
        "displayCents": 27999
      },
      {
        "units": 25,
        "displayCents": 33999
      },
      {
        "units": 30,
        "displayCents": 37999
      },
      {
        "units": 40,
        "displayCents": 45999
      },
      {
        "units": 50,
        "displayCents": 54999
      }
    ]
  },
  "stores": {
    "ios": "live",
    "android": "soon"
  },
  "entitlements": [
    "pro",
    "premium",
    "ai"
  ],
  "freeLimits": {
    "units": 1
  },
  "contact": {
    "support": "support@immoaktas.com",
    "hello": "hallo@immoaktas.com",
    "privacy": "datenschutz@immoaktas.com",
    "noreply": "noreply@immoaktas.com"
  },
  "ids": {
    "appleAppId": "6819831481",
    "ascTeamId": "72RSD32LLC",
    "playPackage": "com.immoaktas.app",
    "androidCertSha256": [
      "B9:CA:5A:45:55:95:21:E1:F3:25:47:F7:B5:E1:DD:C4:CF:F8:0B:C8:E4:41:51:21:2D:58:41:14:BD:E7:84:A6"
    ],
    "firebaseProd": "immoaktas-e5e02",
    "revenuecatProject": "7d5bfe82",
    "cloudflareZoneId": "78de2e9f39e6978dfe6d21f6ecf71674",
    "gitlabProjectId": 87293018
  }
} as const;
export type ProjectConfig = typeof PROJECT;
